import { makeStyles } from '@material-ui/core'

const styles = theme => ({
  table: {
    tableLayout: 'fixed'
  },

  tableHead: {
    backgroundColor: 'rgb(249, 249, 249)',

    '& tr td.new-design-cell': {
      '&:nth-of-type(4), &:nth-of-type(8)': {
        paddingTop: 8,
      }
    }
  },

  tableCell: {
    fontFamily: 'Roboto-Regular',
    fontSize: 14,
    color: '#202A38',
    '&:nth-of-type(4), &:nth-of-type(8)': {
      paddingTop: 13,
    },
    '&:nth-of-type(1)': {
      width: 50,
      textAlign: 'center',
    },
    '&:nth-of-type(2)': {
      width: 250,
    },
    '&:nth-of-type(3)': {
      width: 50,
    },
    '&:nth-of-type(5)': {
      width: 155,
    },
    '&:nth-of-type(6), &:nth-of-type(7)' : {
      '& .MuiInput-root': {
        height: 30,
      }
    },
    '&:nth-of-type(7)': {
      width: 100,
    },
    '&:last-child': {
      width: 45
    },

    '& .ellipsis': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    '& .name': {
      cursor: 'pointer',
      '&:hover': {
        textOverflow: 'initial',
        overflow: 'initial',
        whiteSpace: 'initial',
        wordBreak: 'break-all'
      }
    },
    '& .link': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '& .bold': {
      fontFamily: 'Roboto-Bold',
      fontWeight: 'normal,'
    },
  },

  [theme.breakpoints.down('md')]: {
    tableCell: {
      '&:nth-of-type(2)': {
        width: 180,
      },
    }
  },

  [theme.breakpoints.down('sm')]: {
    tableCell: {
      paddingLeft: 5,
      paddingRight: 5,
      fontSize: 12,
      '&:nth-of-type(2)': {
        width: 100,
      },
    }
  },


  [theme.breakpoints.only('xs')]: {
    tableCell: {
      '& .hide-xs': {
        display: 'none'
      },
      '& .show-xs': {
        display: 'initial'
      }
    }
  },

  tableFooter: {
    background: 'inherit',

    '& .MuiTableCell-root': {
      verticalAlign: 'middle',

      '&:nth-of-type(1), &:nth-of-type(2)': {
        textAlign: 'left'
      },

      '&.new-design-footer-cell': {
        background: '#EEF0F2'
      }
    }
  }
});

export default makeStyles(styles)